export default __webpack_public_path__ + "static/media/iab-step-rewarded-img.ccbe6bbb.svg";